import { useContext } from "react";
import { PublicRequestsContext } from "../contexts/PublicRequestsContext";

export const usePublicRequests = () => useContext(PublicRequestsContext);
